module.exports = __webpack_public_path__ + "static/media/sequence-sentiment.a8d045d4.svg";